export enum ClientUpdateRequestType {
    CLEAR_LAYOUT_CACHE = "CLEAR_LAYOUT_CACHE"
}
